import themes from 'devextreme/ui/themes';
import { DEFAULT_THEME_ID, THEME_CATALOG } from './themeCatalog';

const REGISTRY_MARKER_ID = 'platform-dx-theme-registry';

let registryReady = false;

type ThemesRuntime = typeof themes & {
  init?: () => void;
};

function themeCssHref(cssFile: string): string {
  const base = import.meta.env.BASE_URL ?? '/';
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  return `${normalizedBase}devextreme/css/${cssFile}`;
}

function findExistingThemeLink(themeId: string): HTMLLinkElement | null {
  return document.querySelector(`link[rel="dx-theme"][data-theme="${themeId}"]`);
}

/** Register all predefined themes with DevExtreme (rel=dx-theme links). Call once before applyTheme. */
export function bootstrapThemeRegistry(): void {
  if (typeof document === 'undefined') return;

  const runtime = themes as ThemesRuntime;

  if (!registryReady) {
    for (const entry of THEME_CATALOG) {
      if (findExistingThemeLink(entry.themeId)) continue;

      const link = document.createElement('link');
      link.rel = 'dx-theme';
      link.setAttribute('data-theme', entry.themeId);
      link.href = themeCssHref(entry.cssFile);
      link.setAttribute(
        'data-active',
        entry.themeId === DEFAULT_THEME_ID ? 'true' : 'false'
      );
      link.setAttribute('data-registry', REGISTRY_MARKER_ID);
      document.head.appendChild(link);
    }

    // processMarkup() reads the dx-theme links into a single managed <link rel="stylesheet">.
    // We intentionally do NOT call resetTheme(): it points the active link at "about:blank",
    // which a strict style-src CSP blocks (noisy console error) and serves no purpose here —
    // the registryReady guard already prevents duplicate initialization under StrictMode.
    runtime.init?.();
    registryReady = true;
  }
}
